import React from 'react';
import styled from 'styled-components';
//
import { RichText } from 'components/prismic';
//
export default ({ description, title }) => (
  <Wrap>
    {title && <Title>{title}</Title>}
    {description && <RichText {...description} />}
  </Wrap>
);
//
const Wrap = styled.div`
  padding: 0 0 2rem;
`;
const Title = styled.h2`
  font-size: inherit;
`;
